const ContactPage = () => {
  return (
    <div>
      <h4>Email: Weilj872@gmail.com</h4>
      <div id="button-div">
        <form action="https://www.linkedin.com/in/johnathanweil513/">
          <button className="btn">
            <img
              src="https://i.imgur.com/EX9AedR.png"
              alt="none"
              className="link-btn"
            ></img>
          </button>
        </form>

        <form action="https://github.com/JwR513">
          <button className="btn">
            <img
              src="https://i.imgur.com/ZTLFRho.png"
              alt="none"
              className="link-btn"
              id="github"
            ></img>
          </button>
        </form>
      </div>
    </div>
  )
}

export default ContactPage
